import { useAppSelector } from '../../hooks';
import {
  selectActiveTenantSession,
  selectHasMultipleSessions,
} from '../../containers/Organizations/OrganizationsSlice';
import { isMultiOrgFeatureEnabled } from '../features';

/**
 * Single source for multi-org tenant UI: feature flag + multiple sessions + active session.
 * `showMultiOrgChrome` drives logout copy; `shouldShowActiveTenantBanner` drives
 * `MultiOrgActiveBanner` (side menu, chat file send overlay, documents screens).
 * Ported from cosafe-app `useMultiOrgActiveTenantBanner`.
 */
export function useMultiOrgActiveTenantBanner() {
  const hasMultipleSessions = useAppSelector(selectHasMultipleSessions);
  const activeSession = useAppSelector(selectActiveTenantSession);

  const showMultiOrgChrome = isMultiOrgFeatureEnabled() && hasMultipleSessions;
  const shouldShowActiveTenantBanner = showMultiOrgChrome && activeSession != null;

  return {
    showMultiOrgChrome,
    shouldShowActiveTenantBanner,
    tenantName: activeSession?.tenantName ?? '',
    email: activeSession?.email ?? '',
  };
}
